// extracted by mini-css-extract-plugin
export var field = "story-form-module--field--FudsA";
export var submitButton = "story-form-module--submitButton--4f+vb";
export var falseField = "story-form-module--falseField--rTokK";